import Logger from '@/services/Logger'
import ApiServiceBase from '@/services/ApiServiceBase'

export const namespaced = true

export const state = {
    isServerAlive: true
}

export const mutations = {
    SET_SERVER_IS_ALIVE (state, isAlive) {
        state.isServerAlive = isAlive
    }
}

export const actions = {
    checkServerHeartbeat ({ commit }) {
        return new Promise((resolve) => {
            ApiServiceBase.find({
                resource: 'status/ping',
                query: null
            }).then(() => {
                commit('SET_SERVER_IS_ALIVE', true)
                resolve(true)
            }).catch(err => {
                Logger.error(err)
                commit('SET_SERVER_IS_ALIVE', false)
                resolve(false)
            })
        })
    }
}

export const getters = {
}
